module.exports = __webpack_public_path__ + "media/images/gallery/constellations/ursa_minor/umi_names-a8b1096b519d6bfdf6e5c5ed1b715eed.gif";